import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';
// import scoreVertexShader from '../shader/score/vertex.glsl'
// import scoreFragmentShader from '../shader/score/fragment.glsl'

// import CustomShaderMaterial from 'three-custom-shader-material/vanilla'
import { sendActions } from './socket';

export default class Room {
  constructor(scene, renderer, camera) {
    this.scene = scene;
    this.renderer = renderer;
    this.camera = camera;
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.addLight();

    this.scoreSoundIndex = 0;
    this.deductSoundIndex = 0;
    this.collectables = [];
    this.collectablesRotation = [];
    this.collectableData = { collectable1: {} };
    this.collectablesCollected = 0;
    this.scoreGeo = new THREE.PlaneGeometry(0.5 * 1.08, 0.5);
    this.chocolateCount = 0;
    this.hazelnutCount = 0;
    this.updateResult();
  }

  addLight() {
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2);
    directionalLight.position.set(0, 10, 0);
    this.scene.add(directionalLight);
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'load_complete':
        this.lightUp();
        break;
      case 'collectable_found':
        this.onCollectableFound(data.message.data.collectable);
        break;

      case 'start_game':
        this.startGame(data.message.data);
        break;
      case 'game_count_down':
        this.showMultiplayerCountdown(data.message.data);
        break;
      case 'start_game_timer':
        this.startTimer(data.message.data);
        break;

      case 'game_tick':
        this.onServerGameTick(data.message.data);
        break;
      case 'update':
        this.update();
        break;
      case 'remove_opponent_cookie':
        this.removeOpponentCookie(data.message.data);
        break;
      case 'add_new_cookie':
        this.addItemsFromBackendAroundCamera(
          data.message.data.cookieType,
          data.message.data.spawnData[0]
        );
        break;
      case 'game_over':
        this.stopGame(data.message.data);
        break;
      case 'clear_3d':
        this.killAll();
        break;
    }
  }

  killAll() {
    const meshesToRemove = [];
    this.scene.traverse((child) => {
      if (child.isMesh) {
        child.geometry?.dispose();
        child.material?.dispose();
        meshesToRemove.push(child);
      }
    });
    meshesToRemove.forEach((mesh) => {
      if (mesh.parent) {
        mesh.parent.remove(mesh);
      }
    });
  }

  distroyCollectable(collectable, toRemoveFromArr) {
    if (collectable) {
      collectable.traverse((child) => {
        if (child.geometry) child.geometry.dispose();
      });
      if (toRemoveFromArr) {
        const itemIndexToRemove = collectable.userData.itemIndex;
        const indexToRemove = this.collectables.findIndex(
          (collectable) => collectable.userData.itemIndex === itemIndexToRemove
        );
        if (indexToRemove != -1) {
          this.collectables.splice(indexToRemove, 1);
          this.scene.remove(collectable);
        }
      }
    }
  }

  addScoreUI(pos, scoreKey) {
    const mapItem = Global.assets.textures[scoreKey];
    this.scoreMaterial = new THREE.MeshBasicMaterial({
      map: mapItem.asset,
      transparent: true,
      side: THREE.DoubleSide,
    });

    this.scoreUI = new THREE.Mesh(this.scoreGeo, this.scoreMaterial);
    this.scene.add(this.scoreUI);
    this.scoreUI.position.copy(pos);
    this.scoreUI.lookAt(this.camera.position);

    gsap.fromTo(
      this.scoreUI.scale,
      { x: 0, y: 0, z: 0 },
      {
        x: 0.8,
        y: 0.8,
        z: 0.8,
        duration: 0.5,
        yoyo: false,
        ease: 'back.out(1.7)',
        repeat: 0,
        delay: 0.3,
        onComplete: function (scoreUI) {
          scoreUI.material.dispose();
          this.scene.remove(scoreUI);
        }.bind(this, this.scoreUI),
      }
    );
  }

  removeOpponentCookie(data) {
    document.querySelector('.user_score.opponent .label').innerHTML =
      data.opponentScore;
    this.collectables.forEach((collectable) => {
      if (collectable.userData.itemIndex === data.cookieIndex) {
        this.distroyCollectable(collectable, true);
      }
    });
  }

  onCollectableFound(collectable) {
    // if (Global.soundEnabled) {
    //   document
    //     .querySelector(`#collectSound${(this.collectablesCollected % 2) + 1}`)
    //     .play();
    // }
    // collectable.visible = false;

    gsap.killTweensOf(collectable.position);
    gsap.killTweensOf(collectable.rotation);
    gsap.to(collectable.rotation, {
      y: `+=${Math.PI * 1.75}`,
      duration: 1,
      yoyo: true,
      ease: 'elastic.out(1,0.5)',
    });
    gsap.fromTo(
      collectable.scale,
      { x: 0.25, y: 0.25, z: 0.25 },
      {
        x: 0,
        y: 0,
        z: 0,
        duration: 0.25,
        yoyo: false,
        ease: 'back.in(1.7)',
        repeat: 0,
        delay: 0.15,
        onComplete: function (collectable) {
          this.distroyCollectable(collectable, true);
        }.bind(this, collectable),
      }
    );
    //

    const { collectableType } = collectable.userData;

    if (!Global.isMultiplayer) {
      if (collectableType === 'chocolate') {
        this.chocolateCount--;
        this.addItemsAroundCamera('chocolate');
      } else if (collectableType === 'hazelnut') {
        this.hazelnutCount--;
        this.addItemsAroundCamera('hazelnut');
      }
    } else {
      sendActions('cookie_collected', {
        collectableType,
        itemIndex: collectable.userData.itemIndex,
      });
    }

    collectable.userData.itemType = null;
    if (Global.volumeBool) {
      const soundKey =
        Global.collectableType === collectableType
          ? 'scoreSound'
          : 'deductSound';
      this[`${soundKey}Index`]++;
      if (this[`${soundKey}Index`] > 2) {
        this[`${soundKey}Index`] = 1;
      }
      document.getElementById(`${soundKey}${this[`${soundKey}Index`]}`).play();
    }

    this.addScoreUI(
      collectable.position.clone(),
      Global.collectableType === collectableType
        ? `score${Global.lang}`
        : `deduct${Global.lang}`
    );
    this.updateScore(Global.collectableType === collectableType ? 1 : -1);
    this.collectablesCollected++;
    this.updateResult();
  }

  onDataSaved(v) {
    const result = JSON.parse(v);
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: { event_type: 'end_level', data: {} },
    });
  }

  lightUp() {
    this.environmentMap = Global.assets.cubemap['0'].asset;

    const chocolate = Global.assets.glbs.chocolate.asset.scene;
    const hazelnut = Global.assets.glbs.hazelnut.asset.scene;

    const setupMaterial = (model) => {
      model.traverse((child) => {
        if (!child.material) return;
        const { map } = child.material;
        child.material.envMap = this.environmentMap;
        map.encoding = THREE.sRGBEncoding;
        map.colorSpace = THREE.SRGBColorSpace;
        child.material.metalness = 0.2;
        child.material.roughness = 0.8;
        child.material.envMapIntensity = 2.5;
      });
    };

    setupMaterial(chocolate);
    setupMaterial(hazelnut);
  }

  prepareForGame() {}

  startGame(data) {
    Global.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'clear_3d',
        data: {},
      },
    });
    this.scoreSoundIndex = 0;
    this.deductSoundIndex = 0;
    Global.gameFinished = false;
    document.querySelector('.game_ui').classList.add('active');
    document.querySelector('.game_cover').classList.add('active');
    document.querySelector('.recomonded').classList.add('disabled');
    document.querySelector('.user_score.self .label').innerHTML = '0';
    document.querySelector('.user_score.opponent .label').innerHTML = '0';
    document.querySelector('.user_score.opponent').classList.remove('active');
    document.querySelector('.timer .label').innerHTML = '45';
    document
      .querySelector('.timer_chart')
      .style.setProperty('--percentage', '100%');
    this.placedPositions = [];
    this.collectablesRotation = [];
    this.collectablesCollected = 0;
    this.collectables = [];
    this.chocolateCount = 0;
    this.hazelnutCount = 0;
    this.updateResult();

    this.addFloatingParticles();
    Global.scoreTotal = 0;
    this.updateScore(0);

    if (!Global.isMultiplayer) {
      // this.prepare
      for (let i = 0; i < 5; i++) {
        this.addItemsAroundCamera('chocolate');
        this.addItemsAroundCamera('hazelnut');
      }

      document.querySelector('.timer .label').innerHTML = `${
        Global.gameTime < 10 ? '0' : ''
      }${Global.gameTime}`;
      this.startCountdown();
      // this.startTimer();
    } else {
      for (let i = 0; i < data.initData.length / 2; i++) {
        this.addItemsFromBackendAroundCamera('hazelnut', data.initData[i]);
        if (data.initData[data.initData.length / 2 + i]) {
          this.addItemsFromBackendAroundCamera(
            'chocolate',
            data.initData[data.initData.length / 2 + i]
          );
        }
      }
    }
  }

  showAllCookie() {
    this.collectables.forEach((collectable) => {
      collectable.visible = true;
    });
    this.particlePlanes.forEach((plane) => {
      plane.visible = true;
    });
  }

  showMultiplayerCountdown(data) {
    document.querySelector('.cookie_info').classList.add('active');

    document.querySelector('.game_counter').classList.add('active');
    for (let i = 1; i <= 3; i++) {
      document
        .querySelector(`.game_counter .counter${i}`)
        .classList.remove('active');
    }
    document.querySelector(`.game_counter .counter${data.countdown}`) &&
      document
        .querySelector(`.game_counter .counter${data.countdown}`)
        .classList.add('active');
  }

  startCountdown() {
    document.querySelector('.cookie_info').classList.remove('active');

    let countdownVal = 4;
    document.querySelector('.game_counter').classList.add('active');
    const countdownTI = setInterval(() => {
      for (let i = 1; i <= 3; i++) {
        document
          .querySelector(`.game_counter .counter${i}`)
          .classList.remove('active');
      }

      countdownVal--;
      if (countdownVal <= 0) {
        clearInterval(countdownTI);
        document.querySelector('.game_counter').classList.remove('active');

        this.startTimer();
      } else {
        document
          .querySelector(`.game_counter .counter${countdownVal}`)
          .classList.add('active');
      }
    }, 1000);
  }

  addItemsFromBackendAroundCamera(type, fixedData) {
    if (Global.gameFinished) return false;

    const radius = 2;
    const baseCollectable = Global.assets.glbs[type]?.asset?.scene;
    if (!baseCollectable) {
      console.error(`collectable model not loaded correctly: ${type}`);
      return;
    }

    const x = this.camera.position.x + radius * Math.cos(fixedData.theta);
    const z = this.camera.position.y + -radius * Math.sin(fixedData.theta);
    const y = this.camera.position.z + fixedData.verticalOffset;

    const localPos = new THREE.Vector3(x, y, z);
    const worldPos = localPos.clone().applyMatrix4(this.camera.matrixWorld);

    const collectable = baseCollectable.clone();
    collectable.position.copy(worldPos);
    collectable.scale.set(0.25, 0.25, 0.25);
    collectable.userData.bloom = false;
    collectable.userData.rotationIndex = this.collectablesRotation.length;
    collectable.userData.itemType = 'collectable';
    collectable.visible = Global.isGameActive;
    collectable.userData.itemIndex = fixedData.itemIndex;

    collectable.userData.collectableType = type;
    collectable.userData.found = false;
    this.collectables.push(collectable);
    this.collectablesRotation.push(0.02 * Math.max(0.5, Math.random()));
    this.scene.add(collectable);
  }

  startTimer() {
    this.showAllCookie();
    document.querySelector('.game_counter').classList.remove('active');
    Global.isGameActive = true;
    Global.gameTime = 45;
    if (!Global.isMultiplayer) {
      this.gameTimer = setInterval(() => {
        if (Global.gameTime <= 0) {
          this.stopGame();
          return;
        }
        Global.gameTime--;

        document
          .querySelector('.timer_chart')
          .style.setProperty(
            '--percentage',
            `${Math.floor((Global.gameTime / 45) * 100)}%`
          );
        document.querySelector('.timer .label').innerHTML = `${
          Global.gameTime < 10 ? '0' : ''
        }${Global.gameTime}`;
      }, 1000);
      document.querySelector('.user_score.opponent').classList.remove('active');
    } else {
      document.querySelector('.user_score.opponent').classList.add('active');
    }
  }

  async stopGame(data) {
    document.querySelector('.game_cover').classList.remove('active');
    Global.gameFinished = true;
    let gameStatus = 'win';
    const dataToSent = {
      playerOneScore: 0,
      playerTwoScore: 0,
      player2Left: 0,
      name: null,
      gameTry: Global.gameTry,
      saveType: 'saveScore',
    };

    if (parseInt(Global.playerIndex) === 1) {
      if (Global.isMultiplayer) {
        dataToSent.player2Left = 1;
        const playerData = {};
        const opponentData = {};
        Object.keys(data.gameInfo).forEach((sessionID) => {
          if (sessionID === window.gameRoom.sessionId) {
            playerData.name = data.gameInfo[sessionID].playerName;
            playerData.collectableType =
              data.gameInfo[sessionID].collectableType;
            playerData.scoreTotal = data.gameInfo[sessionID].scoreTotal;
          } else {
            dataToSent.player2Left = 0;
            opponentData.name = data.gameInfo[sessionID].playerName;
            opponentData.collectableType =
              data.gameInfo[sessionID].collectableType;
            opponentData.scoreTotal = data.gameInfo[sessionID].scoreTotal;
          }
        });

        dataToSent.playerOneScore = playerData.scoreTotal;
        dataToSent.playerTwoScore = opponentData.scoreTotal;
        dataToSent.name = opponentData.name;

        if (playerData.scoreTotal < opponentData.scoreTotal) {
          gameStatus = 'fail';
        }
      } else {
        const playerData = {
          name: 'Player1',
          collectableType: Global.collectableType,
          scoreTotal: Global.scoreTotal,
        };
        dataToSent.playerOneScore = playerData.scoreTotal;
      }
      // console.log(dataToSent, 'dataToSent')

      // console.log(dataToSent.player2Left, 'dataToSent.player2Left');
      Global.serverObj.send(
        `${Global.BASE_URL}webservice.php`,
        (response) => {
          response = JSON.parse(response);
        },
        null,
        dataToSent,
        'POST',
        null,
        false
      );
    }
    if (Global.isMultiplayer && Global.playerIndex == 2) {
      const playerData = {};
      const opponentData = {};
      Object.keys(data.gameInfo).forEach((sessionID) => {
        if (sessionID === window.gameRoom.sessionId) {
          playerData.scoreTotal = data.gameInfo[sessionID].scoreTotal;
        } else {
          opponentData.scoreTotal = data.gameInfo[sessionID].scoreTotal;
        }
      });
      if (playerData.scoreTotal < opponentData.scoreTotal) {
        gameStatus = 'fail';
      }
    }

    this.gameTimer && clearInterval(this.gameTimer);
    Global.isGameActive = false;
    document.querySelector('.recomonded').classList.remove('disabled');

    // Destroy all collectables
    this.collectables.forEach((collectable) => {
      this.distroyCollectable(collectable, true);
    });
    this.collectables = [];

    // Destroy particle planes
    if (this.particlePlanes && this.particlePlanes.length) {
      this.particlePlanes.forEach((plane) => {
        if (plane.geometry) plane.geometry.dispose();
        if (plane.material) {
          if (plane.material.map) plane.material.map.dispose();
          plane.material.dispose();
        }
        this.scene.remove(plane);
      });
      this.particlePlanes = [];
    }

    // Destroy score UI if exists
    if (this.scoreUI) {
      if (this.scoreUI.geometry) this.scoreUI.geometry.dispose();
      if (this.scoreUI.material) {
        if (this.scoreUI.material.map) this.scoreUI.material.map.dispose();
        this.scoreUI.material.dispose();
      }
      this.scene.remove(this.scoreUI);
      this.scoreUI = null;
    }

    // Optionally: remove directional light if needed
    // Assuming it's the only light and added by addLight()
    this.scene.children
      .filter((obj) => obj instanceof THREE.DirectionalLight)
      .forEach((light) => this.scene.remove(light));

    document.querySelector('.game_ui').classList.remove('active');
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: gameStatus == 'win' ? 'Score' : 'Score_Fail',
        },
      },
    });
    Global.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'clear_3d',
        data: {},
      },
    });
    if (window.gameRoom) {
      window.gameRoom.removeAllListeners();
      window.gameRoom.connection.close();
      window.gameRoom.leave();
      window.gameRoom = null;
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
  }

  onServerGameTick(data) {
    Global.gameTime = data.gameTime;
    document
      .querySelector('.timer_chart')
      .style.setProperty(
        '--percentage',
        `${Math.floor((Global.gameTime / 45) * 100)}%`
      );
    document.querySelector('.timer .label').innerHTML = `${
      Global.gameTime < 10 ? '0' : ''
    }${Global.gameTime}`;
  }

  addFloatingParticles() {
    this.particlePlanes = [];

    const textureKeys = ['particle1', 'particle2', 'particle3']; // adjust to your actual texture keys
    const textures = textureKeys
      .map((key) => Global.assets.textures[key]?.asset)
      .filter(Boolean);
    textures.forEach((texture) => {
      texture.encoding = THREE.sRGBEncoding;
      texture.colorSpace = THREE.SRGBColorSpace;
    });
    const particleCount = 35;
    const radius = 2.5;
    const zOffset = 0; // -2.5; // behind cookies

    for (let i = 0; i < particleCount; i++) {
      const angle = Math.random() * 2 * Math.PI;
      const y = (Math.random() - 0.5) * 3.5;

      const x = radius * Math.cos(angle);
      const z = radius * Math.sin(angle) + zOffset;

      const pos = new THREE.Vector3(x, y, z).applyMatrix4(
        this.camera.matrixWorld
      );

      const texture = textures[Math.floor(Math.random() * textures.length)];
      const mat = new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true,
        depthWrite: true,
      });

      const size = 0.22 + Math.random() * 0.1;
      const geo = new THREE.PlaneGeometry(size, size);
      const plane = new THREE.Mesh(geo, mat);

      plane.position.copy(pos);
      plane.lookAt(this.camera.position); // Face the camera
      this.scene.add(plane);
      this.particlePlanes.push(plane);
      plane.visible = false;
      const yOffset = 0.05 + Math.random() * 0.05;
      gsap.to(plane.position, {
        y: plane.position.y + yOffset,
        duration: 2 + Math.random(),
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut',
      });

      // Animate slow rotation
      gsap.to(plane.rotation, {
        z: plane.rotation.z + (Math.random() < 0.5 ? 1 : -1) * Math.PI * 2,
        duration: 8 + Math.random() * 4,
        repeat: -1,
        ease: 'none',
      });
    }
  }

  updateResult() {}

  addItemsAroundCamera(type) {
    if (Global.gameFinished) return false;

    const baseCollectable = Global.assets.glbs[type]?.asset?.scene;
    if (!baseCollectable) {
      console.error(`collectable model not loaded correctly: ${type}`);
      return;
    }

    const radius = 2;
    const minDistance = 0.8;
    const verticalLimit = 0.55;

    let attempts = 0;
    const maxAttempts = 500;

    while (attempts < maxAttempts) {
      attempts++;

      const theta = Math.random() * 2 * Math.PI;
      const verticalOffset = (Math.random() * 2 - 1) * verticalLimit;

      const x = this.camera.position.x + radius * Math.cos(theta);
      const z = this.camera.position.y + -radius * Math.sin(theta);
      const y = this.camera.position.z + verticalOffset;

      const localPos = new THREE.Vector3(x, y, z);
      const worldPos = localPos.clone().applyMatrix4(this.camera.matrixWorld);

      const isTooClose = this.collectables.some(
        (collectable) => collectable.position.distanceTo(worldPos) < minDistance
      );
      if (isTooClose) continue;

      const collectable = baseCollectable.clone();

      collectable.position.copy(worldPos);
      collectable.scale.set(0.25, 0.25, 0.25);
      collectable.userData.bloom = false;
      collectable.userData.rotationIndex = this.collectablesRotation.length;
      collectable.userData.itemType = 'collectable';
      collectable.userData.collectableType = type;
      collectable.visible = Global.isGameActive;
      collectable.userData.itemIndex = `item_${Math.random().toFixed(
        3
      )}_${Math.random().toFixed(3)}_sub${Math.random().toFixed(
        3
      )}_${Math.random().toFixed(3)}`;
      collectable.userData.found = false;
      this.collectables.push(collectable);
      this.collectablesRotation.push(0.02 * Math.max(0.5, Math.random()));
      this.scene.add(collectable);

      if (type === 'chocolate') this.chocolateCount++;
      if (type === 'hazelnut') this.hazelnutCount++;
      break;
    }
  }

  updateScore(score) {
    Global.scoreTotal += score;
    Global.scoreTotal = Math.max(0, Global.scoreTotal);
    document.querySelector('.user_score.self .label').innerHTML =
      Global.scoreTotal;
  }

  update() {
    this.collectables.forEach((collectable) => {
      if (collectable.userData.itemType) {
        collectable.rotation.y +=
          this.collectablesRotation[collectable.userData.rotationIndex] * 4;
      }
    });
  }
}
